<template>
  <div class="list">
    <Item
      v-for="(item, index) in dataList"
      :key="index"
      :item="item"
      :type="type"
      @change="change"
    />
  </div>
</template>

<script>
import Item from './item.vue'
export default {
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    type: {
      type: Number,
      default: 1
    }
  },
  components: {
    Item
  },
  methods: {
    change () {
      this.$emit('change')
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 12px;
}
</style>
